module.exports = __webpack_public_path__ + "static/media/team-scott.a512bf25.jpg";